import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from '../utils/Loader';
import { setStatFilters, resetStatFilters, fetchOrdersStat, fetchRobovoiceCallsStatusStat } from '../../action/statistics';
import { fetchCities } from '../../action/handbook';
import Select from 'react-select';
import DateInput from '../utils/DateInput';
import moment from 'moment';
import { utils, writeFileXLSX } from 'xlsx';
import { roleId } from '../../constants/app';

const styles = {
    loading: {
        minHeight: '200px',
        display: 'flex',
        justifyContent: 'center'
    }
}

class OrderStats extends Component {
    componentDidMount() {
       this.props.fetchCities();
    }

    setFilters = (field) => (data) => {
        const { filters } = this.props.orders;
        const updated = {
            ...filters,
            [field]: data
        }
        this.props.setStatFilters('orders', updated);
    }

    onChangeDateInput = (field) => (date) => {
        const { filters } = this.props.orders;

        const updated = {
            ...filters,
            [field]: date,
        };

        if (field === 'createdStartDate') {
            updated.createdEndDate = moment(date).add({ days: 30 }).toDate()
        }

        this.props.setStatFilters('orders', updated);
    }

    resetFilter = () => {
        this.props.resetStatFilters('orders');        
    }

    onSearch = () => {
        this.props.fetchOrdersStat();
    }

    isDisabled = () => {
        const { orders } = this.props
        const { filters } = orders;

        if (filters.createdStartDate && filters.createdEndDate) {
            return false;
        }
        return true;
    }

    onDownloadRobovoiceCallsStatus = () => {
        this.props.fetchRobovoiceCallsStatusStat()
        .then((res) => {
            if(!!res) {
                const robovoicecallsstatus = res.map(item => {
                    return {
                        'id': item.id,
                        'callId': item.callId,
                        'contactId': item.contactId,
                        'campaignId': item.campaignId,
                        'callRequestId': item.callRequestId,
                        'scriptId': item.scriptId,
                        'callURL': item.callURL,
                        'callText': JSON.stringify(item.callText),
                        'message': item.message,
                        'code': item.code,
                        'parameters': JSON.stringify(item.parameters),
                        'status': item.status,
                        'isHumanAnswered': item.isHumanAnswered,
                        'incomingPhone': item.incomingPhone,
                        'outcomingPhone': item.outcomingPhone,
                        'talkTime': item.talkTime,
                        'created_at': moment(item.created_at).format('DD.MM.YYYY HH:mm'),
                        'updated_at': moment(item.updated_at).format('DD.MM.YYYY HH:mm'),
                    }
                })
                const ws = utils.json_to_sheet(robovoicecallsstatus);
                const wb = utils.book_new();
                utils.book_append_sheet(wb, ws, "Data");
                writeFileXLSX(wb, "RobovoiceCallsStatus.xlsx");
            }
        }
        );
    }

    getOptionsSelectCity() {
        const { user, cities } = this.props;
        let options = [];

        if (user.allPoints || user.role.id === roleId.admin) options.push({value: 'all', label: 'Все города'});
        cities.forEach(item => {
            options.push({value: item.id, label: item.name})
        });

        return options;
    }

    renderHead() {
        const { orders } = this.props
        const { loading, filters } = orders;

        return(
            <div className="kt-portlet__head" style={{ flexDirection: 'column', gap: '10px' }}>
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                        Заказы
                    </h3>
                </div>
                <div className="kt-portlet__head-toolbar" style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div className="dateBlock">
                        <DateInput
                            disabled={loading}
                            placeholderText="Дата от"
                            selected={filters.createdStartDate}
                            onChange={this.onChangeDateInput('createdStartDate')}
                            maxDate={moment().toDate()}
                        />
                        <div>-</div>
                        <DateInput
                            disabled={loading}
                            placeholderText="Дата до"
                            selected={filters.createdEndDate}
                            onChange={this.onChangeDateInput('createdEndDate')}
                            maxDate={moment(filters.createdStartDate).add({ days: 30 }).toDate()}
                            required={filters.createdStartDate}
                        />
                    </div>
                    <div style={{ width: 250 }}>
                        <Select
                            isLoading={this.props.loadingCity || loading}
                            isDisabled={this.props.loadingCity || loading}
                            value={filters.city}
                            closeMenuOnSelect={true}
                            options={this.getOptionsSelectCity()}
                            onChange={this.setFilters('city')}
                            placeholder="Город"
                            noOptionsMessage={() => 'Нет городов'}
                        />
                    </div>
                    <button disabled={loading || this.isDisabled() || !filters.city} onClick={this.onSearch} className="btn btn-primary">Найти</button>
                    <button disabled={loading} onClick={this.resetFilter} className="btn btn-danger">Сбросить</button>
                </div>
            </div>
        );
    }

    renderBody() {
        const { orders } = this.props
        const { result, loading, filters } = orders;

        if (!filters.city) return <div>Не указан город</div>;        
        if (loading) return <div style={styles.loading}><Loader /></div>;
        if (!result) return <div>Ничего не найдено</div>;

        return(
            <div className="kt-widget5">
                <div className="kt-widget5__item">
                    <div className="kt-widget5__content">
                        <div className="kt-widget5__section">
                            <p style={{ marginBottom: 0 }} className="kt-widget5__title">
                                Среднее время выполнения заказа
                            </p>
                        </div>
                    </div>
                    <div className="kt-widget5__content">
                        <div style={{ paddingRight: 0 }} className="kt-widget5__stats">
                            <span className="kt-widget5__number">{result ? result.time : 0}</span>
                            <span className="kt-widget5__votes">мин</span>
                        </div>
                    </div>
                </div>
                <div className="kt-widget5__item">
                    <div className="kt-widget5__content">
                        <div className="kt-widget5__section">
                            <p style={{ marginBottom: 0 }} className="kt-widget5__title">
                                Среднее время обработки заказа
                            </p>
                        </div>
                    </div>
                    <div className="kt-widget5__content">
                        <div style={{ paddingRight: 0 }} className="kt-widget5__stats">
                            <span className="kt-widget5__number">{result ? result.progress : 0}</span>
                            <span className="kt-widget5__votes">мин</span>
                        </div>
                    </div>
                </div>
                <div className="kt-widget5__item">
                    <div className="kt-widget5__content">
                        <div className="kt-widget5__section">
                            <p style={{ marginBottom: 0 }} className="kt-widget5__title">
                                Статусы звонков Robovoice
                            </p>
                        </div>
                    </div>
                    <div className="kt-widget5__content">
                        <div style={{ paddingRight: 0 }} className="kt-widget5__stats">
                            <div className="dateBlock" style={{ marginRight: 10 }}>
                                <button onClick={this.onDownloadRobovoiceCallsStatus} className="btn btn-dark btn-icon-sm">Экспорт</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="kt-portlet">
                {this.renderHead()}
                <div className="kt-portlet__body">                    
                   {this.renderBody()}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return ({
        orders: state.statistics.orders,
        cities: state.handbook.cities,
        loadingCity: state.loaders.cities,
        user: state.user.info,
    });
};

const mapDispatchToProps = {
    fetchOrdersStat: () => fetchOrdersStat(),
    fetchRobovoiceCallsStatusStat: () => fetchRobovoiceCallsStatusStat(),
    fetchCities: () => fetchCities(true),
    setStatFilters: (name, filters) => setStatFilters(name, filters),
    resetStatFilters: (name) => resetStatFilters(name),
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderStats);